// extracted by css-extract-rspack-plugin
export default {"cg-field":"cg-field-_miuya","cgField":"cg-field-_miuya"};